import React, { Component } from "react";
import ReactDOM from "react-dom";
import { SCREEN_HEIGHT, SCREEN_WIDTH } from "../common";

// create and get reference to Modal DOM node
const appRoot = document.getElementById("root");
appRoot.insertAdjacentHTML("afterend", '<div id="modal-root"></div>');
const modalRoot = document.getElementById("modal-root");

class InnerModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    const containerStyle = {
      alignItems: "stretch",
      border: "0 solid black",
      boxSizing: "border-box",
      display: "flex",
      flexBasis: "auto",
      flexDirection: "column",
      flexShrink: 0,
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
      minHeight: 0,
      minWidth: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      position: "relative",
      zIndex: 0,

      // modal
      position: "absolute",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      flex: 1,

      // etc
      justifyContent: "center",
      alignItems: "center",
    };

    return ReactDOM.createPortal(
      <div style={containerStyle}>
        <div
          style={{
            width: SCREEN_WIDTH,
            height: SCREEN_HEIGHT,
            display: "flex",
            backgroundColor: this.props.transparent ? "transparent" : "white",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {this.props.children}
        </div>
      </div>,
      this.el
    );
  }
}

export default class WebModal extends Component {
  render() {
    if (this.props.visible) {
      return <InnerModal {...this.props} />;
    }
    return null;
  }
}
